import { render, staticRenderFns } from "./UploadReports.vue?vue&type=template&id=6ca63b14&scoped=true"
import script from "./UploadReports.vue?vue&type=script&lang=js"
export * from "./UploadReports.vue?vue&type=script&lang=js"
import style0 from "./UploadReports.vue?vue&type=style&index=0&id=6ca63b14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca63b14",
  null
  
)

export default component.exports